import { connect } from "react-redux";

import { DebtorType, EmployerType, WageScheduleType } from "types";
import { setWageSchedule } from "actions/wageDebtors";

import PaymentScheduleForm from "./PaymentScheduleForm";

interface DispatchPropsType {
  setWageSchedule(wageSchedule: WageScheduleType): void;
}

interface StatePropsType {
  debtor: DebtorType;
  employer: void | EmployerType;
  wageSchedule: WageScheduleType;
}

const mapDispatchToProps = (dispatch): DispatchPropsType => ({
  setWageSchedule: (wageSchedule): void => {
    dispatch(setWageSchedule(wageSchedule));
  },
});

const mapStateToProps = (state): StatePropsType => ({
  debtor: state.wageDebtors.debtor,
  employer: state.wageDebtors.employer,
  wageSchedule: state.wageDebtors.wageSchedule,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentScheduleForm);
